import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Select } from "../../components/form/formControls";

import {
  loadSubUsers,
  setSelectedUser,
} from "../../store/features/reportSlice";
import { User } from "react-feather";
import { AppColors } from "../../consts/colors";
import { useQuery } from "@tanstack/react-query";
import { fetchSubUsersList } from "../../api/product-service";
import Skeleton from "react-loading-skeleton";

const SubUserSelector = ({ clientHashId = false }) => {
  const dispatch = useDispatch();
  const currentUser = useSelector((s) => s.auth.currentUser);
  const subUsers = useSelector((s) => s.reports.subUsers);
  const selectedUser = useSelector((s) => s.reports.selectedUser);
  const currentProgram = useSelector((s) => s.global.currentProgram);

  const subUserQuery = useQuery(
    ["reports/subusers", {}],
    () =>
      fetchSubUsersList({
        userHashId: currentUser?.userHashId,
        programCode: currentProgram,
        currencyCode: "AED",
      }),
    {
      onSuccess: (res) => {
        // marking default user
        dispatch(setSelectedUser(getCurrentUserAsSubUser()));
        // loading sub users to the store
        dispatch(loadSubUsers([getCurrentUserAsSubUser(), ...res.data]));
      },
    }
  );

  const getCurrentUserAsSubUser = () => {
    return {
      productType: currentUser.productType,
      userHashId: clientHashId
        ? currentUser.clientHashId
        : currentUser.userHashId,
      name: `${currentUser.firstName} ${currentUser.lastName}`,
      email: `${currentUser.emailId}`,
    };
  };

  // useEffect(() => {
  //   dispatch(setSelectedUser(getCurrentUserAsSubUser()));
  // }, []);

  const handleUserSelect = (e) => {
    const { value } = e.target;
    // if (value === currentUser.clientHashId) {
    //   dispatch(setSelectedUser(getCurrentUserAsSubUser()));
    // }
    // find the selected user
    const user = subUsers.find((u) => u.userHashId === value);
    if (user) dispatch(setSelectedUser(user));
  };

  if (subUserQuery.isLoading) return <Skeleton height={25} width={150} />;

  return (
    <div className="input-group ms-3">
      <label className="input-group-text" htmlFor="subuser-selector">
        <User size={12} color={AppColors.grey3} />
      </label>
      <Select
        id={"subuser-selector"}
        className="form-select"
        onChange={(e) => handleUserSelect(e)}
        value={selectedUser?.userHashId}
      >
        <>
          {subUsers?.map((user) => {
            return (
              <>
                <option value={`${user.userHashId}`}>{`${user.name}`}</option>
              </>
            );
          })}
        </>
      </Select>
    </div>
  );
};

export default SubUserSelector;
